import { createApp } from 'vue'

import Notify from '@/utils/notify.js'

import router from "./router";
import App from './App.vue'

const app = createApp(App);

app.config.globalProperties.$notify = Notify;

app.use(router).mount('#app')
